import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var Grid = function (_a) {
    var id = _a.id, children = _a.children, className = _a.className, style = _a.style;
    return (React.createElement("div", { id: id, className: cn(styles.grid, className), style: style }, children));
};
export default Grid;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/grid/index.tsx
// module id = ulkP
// module chunks = 2